// Colores de estado: un único lugar para mesas, mozo, caja, cocina, leyendas y plano.
// Mismo valor en Clásico y Moderno, claro u oscuro. Cada texto encima pasa 4.5:1.

export const TABLE_STATE_COLORS = {
  free: { bg: '#2F855A', fg: '#FFFFFF' },
  occupied: { bg: '#0F4C5C', fg: '#FFFFFF' },
  waiter_call: { bg: '#DC2626', fg: '#FFFFFF' },
  order_ready: { bg: '#D97706', fg: '#1C1917' },
  bill_requested: { bg: '#5B21B6', fg: '#FFFFFF' },
  paying: { bg: '#2563EB', fg: '#FFFFFF' },
  reserved: { bg: '#FFFFFF', fg: '#7C6A46', border: '#7C6A46' },
  to_clean: { bg: '#9CA3AF', bg2: '#A8AFBA', fg: '#111827' },
};

// Cocina por tiempo de espera: iguales en cocina y TV; cada negocio los ajusta en Configuración > Módulos POS
export const KITCHEN_MINUTES = { warning: 15, critical: 25 };

export const KITCHEN_URGENCY = {
  critical: {
    card: 'bg-red-950/80 border-red-500 shadow-lg shadow-red-500/30 border-2',
    bar: 'bg-red-500 animate-pulse',
    code: 'text-red-200',
    timer: 'bg-red-500/30 text-red-200',
    tv: 'border-red-500 bg-red-950/50 animate-pulse',
  },
  warning: {
    card: 'bg-amber-950/60 border-amber-500/70 shadow-lg shadow-amber-500/20',
    bar: 'bg-amber-500',
    code: 'text-amber-200',
    timer: 'bg-amber-500/30 text-amber-200',
    tv: 'border-orange-500 bg-orange-950/30',
  },
  preparing: { card: 'bg-orange-950/40 border-orange-500/50', bar: 'bg-orange-500' },
  normal: {
    card: 'bg-card border-border hover:border-blue-500/50',
    bar: 'bg-blue-500',
    code: 'text-slate-400',
    timer: 'bg-muted text-slate-300',
    tv: 'border-border bg-card',
  },
};

export const kitchenLevel = (createdAt, now, t = KITCHEN_MINUTES) => {
  const mins = Math.floor((now - new Date(createdAt)) / 60000);
  return mins >= t.critical ? 'critical' : mins >= t.warning ? 'warning' : 'normal';
};

export const kitchenThresholds = (settings) => ({
  warning: settings?.kitchen_warning_minutes || KITCHEN_MINUTES.warning,
  critical: settings?.kitchen_critical_minutes || KITCHEN_MINUTES.critical,
});

// Texto legible sobre un color elegido por el negocio (estados de pedido): negro o blanco, el que dé más contraste
const lum = (hex) => {
  const h = (hex || '').replace('#', '');
  if (h.length !== 6) return 0.2;
  return [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16) / 255)
    .map(c => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4))
    .reduce((a, c, i) => a + c * [0.2126, 0.7152, 0.0722][i], 0);
};
export const inkOn = (hex) => ((lum(hex) + 0.05) / 0.05 >= 1.05 / (lum(hex) + 0.05) ? '#000000' : '#FFFFFF');
